import { IPositionCorrectionObject } from "../../../../../domain/editableFormat/objects";
import { IPositionCorrectionObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { RectangleCoordinatableObjectTranslator } from "./base";

export class PositionCorrectionObjectTranslator extends AbstractObjectTranslator<IPositionCorrectionObject, IPositionCorrectionObjectBean> {
  constructor() {
    super(new RectangleCoordinatableObjectTranslator());
  }

  overwriteObject(source: IPositionCorrectionObject, bean: IPositionCorrectionObjectBean, formatId: number): void {
  }

  overwriteBean(source: IPositionCorrectionObjectBean, object: IPositionCorrectionObject): void {
    source["@edit"] = "1";
  }
}
